export default __webpack_public_path__ + "static/media/solucao-01.b3c9031e.webp";